import {
    emojis,
    categories,
    modifiers,
    keywords,
    skinTones
} from './data.json';

export {
    emojis,
    categories,
    modifiers,
    keywords,
    skinTones
};



// WEBPACK FOOTER //
// ./src/emoji-data/index.js